import React from "react";

export interface VectorMoonProps extends React.SVGProps<SVGSVGElement> {
    size?: number | string;
}

const VectorMoon: React.FC<VectorMoonProps> = ({
    size,
    width,
    height,
    className,
    style,
    ...props
}) => {
    const finalWidth = size ?? width ?? "24";
    const finalHeight = size ?? height ?? "24";

    return (
        <svg
            className={className}
            width={finalWidth}
            height={finalHeight}
            style={style}
            viewBox="0 0 50 50"
            preserveAspectRatio="xMidYMid meet"
            {...props}
        >
            {/* Hào quang 2 lớp */}
            <circle cx="25" cy="25" r="18" fill="#fbbf24" opacity="0.6" />
            {/* Mặt trăng tròn */}
            <circle cx="25" cy="25" r="16" fill="#fbbf24" />
        </svg>
    );
};

export default VectorMoon;
